<template>
    <PageFull header="Счет" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full px-3">                
                <div v-if="account" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row" >
                    <div class="w-full flex flex-column gap-3" >
                        <div v-if="account" class="w-full flex flex-column gap-0">
                            <div v-if="account.id" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Account ID: 
                                </span>
                                <span class="flex my-auto overflow-hidden" style="max-width:10em">
                                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                        {{ account.id }}
                                    </span>
                                </span>...
                                <Button @click="copy(account.id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div v-if="account.wallet_id" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Wallet ID: 
                                </span>
                                <span class="flex my-auto overflow-hidden" style="max-width:10em">
                                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                        {{ account.wallet_id }}
                                    </span>
                                </span>...
                                <Button @click="copy(account.wallet_id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                                <Button @click="goToWallet(account.wallet_id)" icon="pi pi-external-link" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                            <div v-if="account.type" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Тип: 
                                </span>
                                <span class="flex flex-row gap-2 my-auto overflow-hidden">
                                    <Tag class="flex" :value="GetWalletNameByLabel(account.type)" :class="getClassByLabel(account.type)" />
                                    <Tag class="flex" :value="GetWalletNameByLabel(account.ext_type)" :class="getClassByLabel(account.ext_type)"/>
                                </span>
                                <Button @click="copy(account.ext_type)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Баланс: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ formaAmount(account.balance, account.currency, 2) }} ({{ account.balance }} {{ account.currency }})
                                </span>
                                <Button @click="copy(account.balance)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div v-if="account.description" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Описание: 
                                </span>
                                <span class="flex my-auto overflow-hidden bg-yellow-100">
                                    {{ account.description }}
                                </span>
                                <Button @click="copy(account.description)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                            <div v-if="account.created_at" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Создан: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ formatDate(account.created_at) }}
                                </span>
                                <Button @click="copy(account.created_at)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div v-if="account.updated_at" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Обновлен: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ formatDate(account.updated_at) }}
                                </span>
                                <Button @click="copy(account.updated_at)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                        </div>

                        <Topup v-if="account.wallet_id"
                            :max_amount="account.balance"
                            :wallet_id="account.wallet_id"
                            :currency_code="account.currency" />

                        <TransList v-if='transactions && transactions.length > 0' 
                            :transactions="transactions" :total="totalRecords" :account_id="account_id" :loading="loading"
                            @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams"/> 
                        <span v-else-if="transactions && transactions.length === 0">
                            Нет транзакций
                        </span>
                    </div>
                </div>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import PageFull from '@/components/sides/PageFull.vue'
import TransList from '@/components/admin/transaction/list.vue'
import Topup from '@/components/admin/account/Topup.vue'

export default {
    data() {
        return {
            account_id: null,
            account: null,
            transactions: [],
            loading: false,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            totalRecords: 0,
        }
    },
    components: {
        PageFull,
        TransList,
        Topup
    },
    methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        goToWallet(id){
            if(!id) return
            window.open(`/admin/wallet/${id}/`, '_blank')
        },
        formaAmount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.GetAccount();
        },
        setParams(params) {
            this.lazyParams = params
            this.GetAccount()
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
        async GetAccount() {
            this.loading = true
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
                const account_data = await this.connect.get_account_by_id(this.account_id, this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res=>res)
                if(account_data.result) {
                    this.account = account_data.data.account
                    this.transactions = account_data.data.transactions
                    this.totalRecords = account_data.data.total
                }
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.account_id = route.params.id
            this.GetAccount()
        } else {
            this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Неверный ID счета', life: 3000 });
            this.account = null
            this.transactions = []
            this.totalRecords = 0
        }
    },
}
</script>